module.exports = "<span #mathField></span>"